import React from 'react'
import GamePromotion from '../components/GamePromotion'

const games = [
    {
        title: 'Alice in Dreamland',
        slug: 'alice'
    },
    {
        title: 'Quantra Ascendra',
        slug: 'quantra'
    }
]

export default function GamesPage() {
    return (
        <main className='main'>
            <section className='games-section'>
                <div className='container'>
                    {games.map((game, index) => (
                        <div key={game.slug} className='game-promotion-wrapper'>
                            <GamePromotion
                                title={game.title}
                                slug={game.slug}
                                showMeet={false}
                            />
                        </div>
                    ))}
                </div>                
            </section>
        </main>
    )
}



